import { Page } from 'common-front/src/components/page/page';
import { Box } from 'common/src/designSystem/components/box';
import { useTranslate } from 'common/src/util/dependencies/dependencies';
import * as React from 'react';

export const AccreditationsAssignmentsHeader = () => {
    const translate = useTranslate();

    return (
        <Page.Header direction="column">
            <Box font="blueGray900 textXl medium">{translate('accr_ditations_39450')}</Box>
            <Box color="gray500">{translate('accr_diter_vos_35773')}</Box>
        </Page.Header>
    );
};
